import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ServicesContext } from '~/services';
import { enumValue, gapIsFailed, gapIsPending } from '~/util';
import { useRoleActions } from '~/util/useRoleActions';

interface UnanswerProps {
    hcc: RiskGapType;
    patientId: number;
}
export function Unanswer({ hcc, patientId }: UnanswerProps) {
    const servicesContext = React.useContext(ServicesContext);
    const canUnanswer = useRoleActions('allow_save_edit_answer_risk_gap');
    const [saving, setSaving] = React.useState(false);

    const shouldDisplay =
        canUnanswer &&
        (gapIsPending(hcc) || gapIsFailed(hcc)) &&
        !hcc.is_added &&
        hcc.submission_answer;

    async function unset() {
        setSaving(true);
        if (enumValue(['submission', 'status', 'New']) === hcc.submission_answer?.status) {
            await servicesContext.patient.deleteSubmissionAnswer(
                enumValue(['gap', 'type', 'Risk Gap']),
                hcc.id,
                hcc.submission_answer.id
            );
        } else {
            await servicesContext.patient.updateRiskGap(hcc.id, patientId, {
                submission_answer: null,
                updated_at: hcc.updated_at,
            });
        }
        setSaving(false);
    }

    return shouldDisplay ? (
        <div className="text-center">
            <button className="btn btn-warning" type="button" disabled={saving} onClick={unset}>
                {saving && <Spinner animation="border" size="sm" role="status" className="me-2" />}
                Clear
            </button>
        </div>
    ) : null;
}
